const state = {
    user: {},
    ticket_unread: 0,
    news_unread: 0
}

const mutations = {
    setUser (state, data) {
        state.user = data
    },
    setTicketUnread (state, data) {
        state.ticket_unread = data
    },
    setNewsUnread (state, data) {
        state.news_unread = data
    }
}

const actions = {
    getUser ({ commit }) {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            window.axios.get(`/profile?expand=balances`)
                .then((res) => {
                    commit('setUser', res.data)
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                })
        })
    },
    getUnread ({ commit }) {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            window.axios.get(`/profile/unread`)
                .then((res) => {
                    commit('setTicketUnread', res.data.ticket)
                    commit('setNewsUnread', res.data.news)
                    resolve(res)
                }).catch((error) => {
                reject(error)
            })
        })
    },
    // getTicketUnread ({ commit }) {
    //     return new Promise((resolve, reject) => { // The Promise used for router redirect in login
    //         window.axios.get(`/tickets/unread`)
    //             .then((res) => {
    //                 commit('setTicketUnread', res.data.count)
    //                 resolve(res)
    //             }).catch((error) => {
    //             reject(error)
    //         })
    //     })
    // },
    // getNewsUnread ({ commit }) {
    //     return new Promise((resolve, reject) => { // The Promise used for router redirect in login
    //         window.axios.get(`/news/unread`)
    //             .then((res) => {
    //                 commit('setNewsUnread', res.data.count)
    //                 resolve(res)
    //             }).catch((error) => {
    //             reject(error)
    //         })
    //     })
    // }
}

const getters = {
    getUser: state => state.user,
    getTicketUnread: state => state.ticket_unread,
    getNewsUnread: state => state.news_unread
}

export default {
    state,
    mutations,
    actions,
    getters
}
